import { Outlet, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { motion, AnimatePresence } from "framer-motion";
import "@/components/home/home-theme.css";
import "@/styles/public-dark.css";
import Header from "@/components/public/Header";
import Footer from "@/components/public/Footer";
import WhatsAppFloatingButton from "@/components/public/WhatsAppFloatingButton";
import TrackingScripts from "@/components/public/TrackingScripts";
import { organizationJsonLd } from "@/components/public/SEO";
import { useSiteSettings } from "@/lib/SiteSettingsContext";
import { easeOutStrong } from "@/lib/motion";

export default function PublicLayout() {
    const { settings } = useSiteSettings();
    const location = useLocation();
    const origin =
        process.env.REACT_APP_SITE_URL ||
        (typeof window !== "undefined" ? window.location.origin : "");
    const org = organizationJsonLd(settings, origin);
    return (
        <div className="home-theme public-theme min-h-screen flex flex-col">
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(org)}</script>
            </Helmet>
            <TrackingScripts />
            <Header />
            <main className="flex-1">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={location.pathname}
                        initial={{ opacity: 0, y: 24 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -12 }}
                        transition={{ duration: 0.35, ease: easeOutStrong }}
                        style={{ willChange: "transform, opacity" }}
                    >
                        <Outlet />
                    </motion.div>
                </AnimatePresence>
            </main>
            <Footer />
            <WhatsAppFloatingButton />
        </div>
    );
}
